import { createSelector } from 'reselect'

const gameSelector = state => state.game

export default createSelector(
	[ gameSelector],
	game => game
)
